export const environment = {
  production: true,
  appAuthorizationName: "crm.base",
  appVersion: require('../../package.json').version + '-dev',
  apiFlowConfig: {
    apiName: 'crm',
    urlBase: "digit4ll.dev",
    apiUrl: 'https://crm.digit4ll.dev/api/v1/usr/',
    apiUrlMd: 'https://md.digit4ll.dev/api/v1/usr/',
    apiUrlMrp: 'https://mrp.digit4ll.dev/api/v1/usr/',
    apiUrlOrchestrator: 'https://admin.digit4ll.dev/api/v2/',
    sharedUrl: 'https://shared.digit4ll.dev',
    accountAppUrl: 'https://login.digit4ll.dev',
    loginUrl: 'https://login.digit4ll.dev',
    accountUrl : "https://apps.digit4ll.dev/home/account",
    homeAppUrl: 'https://home.digit4ll.dev/',
    appsUrl: 'https://apps.digit4ll.dev',
    externalPoolUrl : 'https://pool-window.digit4ll.dev',
    menuImplementationUrl: '',
    appsUrlApiFlask: '',
    menuFromOrchestrator : true,
  },
  appUrlsReplacement: [
    { appName: "home", urlReplacement: "https://home.digit4ll.dev" },
    { appName: "expense", urlReplacement: "https://expense.digit4ll.dev" },
    { appName: "frm", urlReplacement: "https://frm.digit4ll.dev" },
    { appName: "kpis", urlReplacement: "https://kpis.digit4ll.dev" },
    { appName: "orchestrator", urlReplacement: "https://admin.digit4ll.dev" },
    { appName: "planning", urlReplacement: "https://planning.digit4ll.dev" },
    { appName: "mrp", urlReplacement: "https://mrp.digit4ll.dev" },
    { appName: "crm", urlReplacement: "https://crm.digit4ll.dev" },
    { appName: "time", urlReplacement: "https://time.digit4ll.dev" },
    { appName: "som", urlReplacement: "https://som.digit4ll.dev" },
    { appName: "hrm", urlReplacement: "https://hrm.digit4ll.dev" }
  ],
  accesRouteMapping:
    [
      // {route : "/contacts" , permissionName : "orchestrator.users.edit" },
    ]
};


export const authPasswordFlowConfig: any = {
  issuer: 'https://login.digit4ll.dev/api/v1',
  tokenEndpoint: 'https://login.digit4ll.dev/api/v1/connect/token',
  redirectUri: window.location.origin + '/index.html',
  silentRefreshRedirectUri: window.location.origin + '/index.html',
  loginUrl: window.location.origin + '/login.html',
  clientId: 'dev.digit4ll.extranet',
  dummyClientSecret: 'f8SGbQp3UpnzrnVCUbM3CbZPjmw8e7UX',
  scope: 'extranet.user orchestrator.user expense.user home.user time.user identities.user openid offline_access',
  showDebugInformation: true,
  oidc: false
};
